<dx-data-grid [height]="174" width="100%" [dataSource]="dataSource" [allowColumnResizing]="true"
    [allowColumnReordering]="false" [columnAutoWidth]="true">
    <dxo-editing [allowUpdating]="false" [allowAdding]="false" [allowDeleting]="false" [allowResizing]="false">
    </dxo-editing>
    <dxo-paging [enabled]="false"></dxo-paging>
    <dxo-scrolling mode="virtual" columnRenderingMode="virtual" rowRenderingMode="virtual" showScrollbar="always" useNative="false" preloadEnabled="true"></dxo-scrolling>
    <dxo-filter-row [visible]="false"></dxo-filter-row>
    <dxo-header-filter [visible]="false"></dxo-header-filter>
    <dxo-group-panel [visible]="false"></dxo-group-panel>
    <dxo-search-panel [visible]="false" [width]="240" placeholder="Search..."></dxo-search-panel>

    <dxi-column dataField="Id" dataType="date" [visible]="false">
    </dxi-column>
    <dxi-column dataField="SignedOn" dataType="date" caption="Signed On" format="d MMM yyyy HH:mm" sortIndex="1"
        sortOrder="desc" [width]="150">
    </dxi-column>
    <dxi-column dataField="DisclaimerRef" caption="Ref">
    </dxi-column>
    <dxi-column dataField="DisclaimerType" caption="Type">
    </dxi-column>
    <dxi-column dataField="DisclaimerName" caption="Name">
    </dxi-column>
    <dxi-column dataField="DisclaimerVersion" caption="Version">
    </dxi-column>
    <dxi-column dataField="SigningMethod" caption="Signing Method">
    </dxi-column>
</dx-data-grid>